import { render } from "./FooterItem.vue?vue&type=template&id=e1d40010"
import script from "./FooterItem.vue?vue&type=script&lang=js"
export * from "./FooterItem.vue?vue&type=script&lang=js"

import "./FooterItem.vue?vue&type=style&index=0&id=e1d40010&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__